import React, { useEffect, useRef, useState } from 'react';
// import { scrollIntoView } from 'seamless-scroll-polyfill';
import { CSSTransition } from 'react-transition-group';
import { truncate } from 'lodash';
import cn from 'classnames';
import { Button } from 'react-bootstrap';
import { TiChevronLeft } from 'react-icons/ti';
import TicketPurchasing from 'widget/event_components/ticket-purchasing';
import styles from '../checkout.scss';

export const RedesignCheckout = ({ event, settings, openTicketing, onClose, transitionClassName = '', inClassName = '', onResizeComponent }) => {
  const title = window.isMobileType
    ? event.get('title')
    : truncate(event.get('title'), {
        length: 20,
      });
  const [height, setHeight] = useState('100%');
  const ref = useRef(null);

  useEffect(() => {
    if (!openTicketing) return;

    if (!ref) return;

    if (ref?.current && ref?.current?.clientHeight === 0) {
      setHeight(ref.current.clientHeight);
    }
  }, [height, ref]);

  const ticketSpotEnabled = event.get('use_checkout_form') && event.get('type') === 'eventviewer';

  if (!openTicketing || !ticketSpotEnabled) return null;

  return (
    <CSSTransition className={transitionClassName} classNames="checkout-fade" timeout={0} in={openTicketing}>
      <div
        className={`${inClassName} ${styles.checkout}`}
        style={{ position: 'relative', minHeight: height, height: '100%', width: '100%', overflow: 'auto' }}
        ref={ref}
        id={`checkout-${event.get('id')}`}
      >
        <div style={{ minHeight: 250, display: 'flex', flexDirection: 'column' }}>
          {onClose && (
            <span className="back" onClick={onClose}>
              <Button className={cn('attendee_button', { 'square-buttons': !settings.get('buttonRounded') })}>
                <TiChevronLeft size={25} className="checkout-arrow" />
                {title}
              </Button>
            </span>
          )}
          <TicketPurchasing event={event} settings={settings} open={openTicketing} onResizeComponent={onResizeComponent} />
        </div>
      </div>
    </CSSTransition>
  );
};
